/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable unicorn/prefer-module */
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { ListadoFacturas, Header, BuildingDetailsModal } from "../../components";
import { EDIFICIOS_EXCLUIDOS } from "../../constants/permisos";
import { useAuthContext } from "../../context/auth";
import {
  getEdificiosOperativos,
  getFacturasComision2,
  getFacturasComisionTodos,
  getClientes,
  getOportunidadesBTL,
  getContratos,
  log,
  calcularImporteNetoIntermediario,
  calcularPorcentajeComisionIntermediario,
  obtenerNombreIntermediario,
  getConvertedImporte,
  calcularComisionEdificiosTotal,
  resolverDesgloseComision,
  explodarContratosComoFacturas,
  esEdificioComisionFija,
} from "../../utils";
import { getApxMonto } from "../../utils/apx";
import { getRateForOpp } from "../../utils/calculateVentas";
import { cargarCobroPorVenta } from "../../utils/cobro/cargarCobroVentas";
import { cargarSnapshotComision, cargarSnapshotPctCongelado } from "../../utils/comisionSnapshot";
import { cargarCostosIntermediacion, getTakeLocal } from "../../utils/costosIntermediacion";
import { getSaldoEdificio } from "../../utils/getSaldoEdificio";
import { socioEnFecha, cargarHistorialSocios } from "../../utils/socioEdificio";
import { client, supabase } from "../../utils/supabase";
import { useExchangeRates } from "../../utils/useExchangeRates";
import "./stylesCalculadorComisionEdificio.scss";

// Etiqueta legible del estado de cada consulta base (diagnóstico visible del bloque vacío/error).
const ESTADO_CARGA_LABEL = { ok: "ok", empty: "vacío", failed: "fallo" };

const regexFecha = /^(20\d{2})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const MESES_NOMBRE = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome");
};

export const CalculadorComisionEdificio = () => {
  // const [edificios, setEdificios] = useState([]);
  const [facturas, setFacturas] = useState(null);
  const [todosEdificios, setTodosEdificios] = useState([]);
  // Fase 2 — agrupación por DUEÑO (socio) resuelto POR FECHA (edificio_socio_historial), no por el
  // valor actual de `edificios.alianza`. El dropdown de grupos emite `socio:<id>`.
  const [socios, setSocios] = useState([]);
  const [historialPorEdificio, setHistorialPorEdificio] = useState(new Map());
  const esSeleccionSocio = useCallback((v) => typeof v === "string" && v.startsWith("socio:"), []);
  const socioIdSel = useCallback((v) => (esSeleccionSocio(v) ? Number(v.slice(6)) : null), [esSeleccionSocio]);
  const edificioTuvoSocio = useCallback(
    (edId, socioId) => (historialPorEdificio.get(Number(edId)) || []).some((r) => r.socio_id === socioId),
    [historialPorEdificio]
  );
  // Operativos SIN filtrar por edificiosOk: el modal de detalle muestra todas las filas de la
  // venta (pantallas/inversión de todos los edificios), aunque %/costo se recorten por edificio.
  const [edificiosFull, setEdificiosFull] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);
  const [intermediarios, setIntermediarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  // Error REAL de cada carga base (null = ok o vacío-sin-error). Distingue "falló la consulta"
  // de "respondió bien pero vino vacía": el mensaje de error no puede ser el mismo para ambos.
  const [intermediariosError, setIntermediariosError] = useState(null);
  const [clientesError, setClientesError] = useState(null);
  // Diagnóstico VISIBLE de la última carga: por fuente { status: ok|empty|failed, count, error }.
  // Se muestra en el bloque vacío/error para no tener un cartel mudo (no se sabía cuál array venía
  // vacío ni por qué, sin poder ver el runtime desde Cowork). Puede quedar como info permanente.
  const [diag, setDiag] = useState(null);
  // Excepción FATAL de fetchData: cualquier throw dentro del try (que antes caía en un catch MUDO y se
  // veía como "no hay datos"). Guardarla acá la muestra como fallo real y deja el mensaje + stack (10.177).
  const [cargaError, setCargaError] = useState(null);
  // Snapshot de comisión (Paso 5): denominador congelado por país. Fallback a pantallastotales.
  const [snapMap, setSnapMap] = useState(null);
  // A3 (7.22): % de intermediación congelado (foto). Vacío/null → todo en vivo.
  const [pctMap, setPctMap] = useState(null);
  const [costosMap, setCostosMap] = useState(null);
  const [investmentType, setInvestmentType] = useState("todas");
  const [activeTab, setActiveTab] = useState("variable");
  const [vistaActiva, setVistaActiva] = useState("comision");
  // Arranca en TRUE y SOLO pasa a false dentro de fetchData (cuando una carga terminó de verdad). Por lo
  // tanto `isLoading === false` ⟺ "al menos una carga terminó y ninguna está en curso". Combinado con
  // `authLoading` en el render, garantiza el invariante: las ramas de vacío/error son inalcanzables hasta
  // que el auth resolvió Y una carga terminó (ver el bloque de render).
  const [isLoading, setIsLoading] = useState(true);
  // Contador de corrida: si dos fetchData se solapan, la respuesta de una vieja no debe pisar el estado
  // de una más nueva. Cada corrida toma su id al arrancar y descarta su resultado si ya no es la vigente.
  const runIdRef = useRef(0);
  const [pagosEdificio, setPagosEdificio] = useState([]);
  const [totalesListado, setTotalesListado] = useState({
    bruto: null,
    neto: null,
    comisionIntermediario: null,
    generada: null,
    recaudada: null,
    pendiente: null,
  });
  const [historico, setHistorico] = useState({
    bruto: null,
    neto: null,
    comisionIntermediario: null,
    generada: null,
    recaudada: null,
    movimientos: [],
    loading: false,
  });
  // Referencia estable para evitar loop infinito en ListadoFacturas (useEffect deps).
  const handleTotalesCalculados = useCallback((t) => setTotalesListado(t), []);
  const lastFormValues = useRef({ edificio: "0", fechaInicio: "", fechaFin: "", investmentType: "todas" });
  // `authLoading` = isLoading del contexto de auth (authLoading || userLoading || stillLoadingUser).
  // Mientras sea true, pais/rol/edificiosOk NO son definitivos (llegan async tras el primer render):
  // la carga se gatea por acá para no consultar —ni evaluar vacío— con datos a medio resolver.
  const { pais, edificiosOk, rol, isLoading: authLoading } = useAuthContext() || {};
  const isDemoMode = rol === "edificio" && (!edificiosOk || edificiosOk.length === 0);
  // Bloqueo de acceso al reporte para edificios de Visiona/Perú (pais por hostname visiona.pe). SOLO
  // rol edificio + Perú: no afecta Chile/Wecast ni ningún otro rol (Priscilla es gerencia, no entra).
  const bloqueadoEdificioPeru = rol === "edificio" && pais === "Perú";
  const { getDolarValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);

  const { handleSubmit, register, watch } = useForm({ defaultValues: { edificio: "0" } });
  const [edificioSeleccionado, fechaInicio, fechaFin] = watch(["edificio", "fechaInicio", "fechaFin"]);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$ ",
        Perú: "S/ ",
        Uruguay: "$ ",
      })[pais] || "$ ",
    []
  );

  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[pais] || 0,
    []
  );

  // Map completo de operativos (id → edificio) para el modal de detalle. Usa edificiosFull
  // (sin filtrar por edificiosOk) para que el desglose muestre TODAS las filas de la venta.
  const edificiosMapModal = useMemo(
    () =>
      edificiosFull.reduce((acc, e) => {
        if (e.id) acc[e.id] = e;
        return acc;
      }, {}),
    [edificiosFull]
  );

  // getRate por venta para el modal (misma cascada que el listado: facturafecha → fecha_cierre → …).
  const getRateModal = useCallback(
    (opp) => getRateForOpp(opp, getDolarValue, dolarFallback[pais]),
    [getDolarValue, dolarFallback, pais]
  );

  // Datos para tab Fijos: comisiones fijas mensuales por edificio
  const datosFijos = useMemo(() => {
    if (
      !fechaInicio ||
      !fechaFin ||
      todosEdificios.length === 0 ||
      !regexFecha.test(fechaInicio) ||
      !regexFecha.test(fechaFin)
    ) {
      return null;
    }

    // Determinar qué edificios mostrar (grupo por DUEÑO-en-fecha, Fase 2)
    let edificiosGrupo = [];
    const socioIdFijos = socioIdSel(edificioSeleccionado);
    const esIndividual =
      edificioSeleccionado !== "0" && edificioSeleccionado !== "todos" && !esSeleccionSocio(edificioSeleccionado);

    if (edificioSeleccionado === "todos") {
      edificiosGrupo = todosEdificios;
    } else if (esSeleccionSocio(edificioSeleccionado)) {
      edificiosGrupo = todosEdificios.filter((ed) => edificioTuvoSocio(ed.id, socioIdFijos));
    } else {
      const ed = todosEdificios.find((e) => e.id === Number(edificioSeleccionado));
      if (ed) edificiosGrupo = [ed];
    }

    // Filtrar a edificios con comisión fija
    const edificiosFijos = edificiosGrupo.filter((ed) => ed.comision_fija_monto > 0 && ed.comision_fija_inicio);
    if (edificiosFijos.length === 0) return { edificiosFijos: [], esIndividual, filas: [], resumen: [] };

    // Generar rango de meses (parseo manual para evitar bug timezone UTC vs local)
    const [sY, sM] = fechaInicio.split("-").map(Number);
    const [eY, eM] = fechaFin.split("-").map(Number);
    const meses = [];
    let curY = sY,
      curM = sM;
    while (curY < eY || (curY === eY && curM <= eM)) {
      meses.push({ year: curY, month: curM, fechaPrimero: `${curY}-${String(curM).padStart(2, "0")}-01` });
      curM++;
      if (curM > 12) {
        curM = 1;
        curY++;
      }
    }

    if (esIndividual && edificiosFijos.length === 1) {
      // Edificio individual: detalle mensual
      const ed = edificiosFijos[0];
      const montoUSD = Number(ed.comision_fija_monto);
      const filas = meses
        .filter((mes) => esEdificioComisionFija(ed, mes.fechaPrimero))
        .map((mes) => {
          const tc = getDolarValue(mes.fechaPrimero);
          return { periodo: `${MESES_NOMBRE[mes.month - 1]} ${mes.year}`, montoUSD, tc, montoLocal: montoUSD * tc };
        });
      return { edificiosFijos, esIndividual: true, filas, resumen: [] };
    }

    // Alianza/Todos: resumen por edificio
    const resumen = edificiosFijos.map((ed) => {
      const montoUSD = Number(ed.comision_fija_monto);
      // Fase 2: con grupo por dueño, cada mes de fija cuenta solo si ese dueño era el vigente ese mes.
      const mesesActivos = meses.filter(
        (m) =>
          esEdificioComisionFija(ed, m.fechaPrimero) &&
          (socioIdFijos == null || socioEnFecha(historialPorEdificio, ed.id, m.fechaPrimero) === socioIdFijos)
      );
      let totalLocal = 0;
      mesesActivos.forEach((m) => {
        totalLocal += montoUSD * getDolarValue(m.fechaPrimero);
      });
      return {
        edificio: ed.edificio,
        montoMensualUSD: montoUSD,
        cantMeses: mesesActivos.length,
        totalUSD: montoUSD * mesesActivos.length,
        totalLocal,
      };
    });
    return { edificiosFijos, esIndividual: false, filas: [], resumen };
  }, [
    edificioSeleccionado,
    fechaInicio,
    fechaFin,
    todosEdificios,
    historialPorEdificio,
    esSeleccionSocio,
    socioIdSel,
    edificioTuvoSocio,
    getDolarValue,
  ]);

  // Carga base reutilizable (useCallback) para poder reintentarla desde el botón del bloque de error
  // sin recargar la página. Deps: authLoading, pais, isDemoMode (redispara al resolver el auth).
  const fetchData = useCallback(async () => {
    // GATE POR AUTH: mientras el auth no resolvió (authLoading), pais/rol/edificiosOk NO son definitivos
    // → no consultamos y quedamos en Cargando. Recién con authLoading=false, isDemoMode y pais ya son
    // finales, así que la carga corre UNA sola vez (isDemoMode ya no cambia después). `authLoading` está
    // en las deps: cuando pasa a false, el efecto redispara fetchData.
    if (authLoading) return;
    if (isDemoMode) return; // demo lo resuelve el early-return del render; no consultamos
    if (!pais) return; // defensivo: con el auth resuelto, pais siempre está (default por hostname)
    // Contador de corrida (punto 5): tomamos el id de ESTA corrida; si al volver del await ya no es la
    // vigente (arrancó otra), descartamos el resultado sin pisar estado ni tocar isLoading.
    const myRun = ++runIdRef.current;
    setIsLoading(true);
    // Cada consulta se resuelve por SEPARADO: el fallo de una NO tira abajo a las otras. Antes
    // getClientes re-lanzaba y rechazaba el Promise.all entero → los 5 estados quedaban vacíos y la
    // pantalla moría con un mensaje falso de "no hay datos". `settle` clasifica cada getter:
    //   - "ok": vino con filas.
    //   - "empty": respondió bien pero sin filas (getClientes/getIntermediarios lanzan
    //             Error("No data found") en ese caso → es VACÍO, no un fallo de carga).
    //   - "failed": error real de carga (red/auth) → se guarda para mostrar el mensaje verdadero.
    // OJO (10.170): getIntermediarios traga sus errores internamente (devuelve undefined), así que
    // un fallo silencioso suyo se observa acá como "empty". No se corrige en el getter porque es
    // compartido por 40+ consumidores (10.14); queda como deuda conocida. El culpable real de la
    // pantalla muerta era getClientes, que SÍ re-lanza → rechazaba el Promise.all entero.
    const settle = async (fn) => {
      try {
        const data = await fn();
        return data && data.length > 0 ? { status: "ok", data } : { status: "empty", data: [] };
      } catch (err) {
        if (err?.message === "No data found") return { status: "empty", data: [] };
        return { status: "failed", data: [], error: err };
      }
    };
    try {
      const [interRes, cliRes, snap, costos, pct] = await Promise.all([
        // DIAGNÓSTICO (10.170): getIntermediarios() traga sus errores y devuelve undefined → un fallo
        // suyo se vería como "vacío". Acá llamamos al wrapper directo (misma query: order=nombre), que
        // SÍ propaga el error, para poder distinguir vacío-real de fallo. No se toca el getter compartido.
        settle(() => supabase.select("intermediarios", { orderBy: "nombre" })),
        settle(() => getClientes({ pais })),
        cargarSnapshotComision(pais).catch(() => null),
        cargarCostosIntermediacion(pais).catch(() => null),
        cargarSnapshotPctCongelado(pais).catch(() => null),
      ]);
      // Corrida obsoleta (arrancó otra mientras esperábamos) → descartar sin tocar estado ni isLoading.
      if (myRun !== runIdRef.current) return;
      setSnapMap(snap);
      setCostosMap(costos);
      setPctMap(pct);

      // NORMALIZAR TIPOS PARA EVITAR BUGS DE STRING VS NUMBER
      const intermediariosNormalizados = (interRes.data || []).map((i) => ({
        ...i,
        id: Number(i.id),
      }));

      const clientesNormalizados = (cliRes.data || []).map((c) => ({
        ...c,
        id: Number(c.id),
        agencia: c.agencia ? String(c.agencia).trim() : null,
      }));

      setIntermediarios(intermediariosNormalizados);
      setClientes(clientesNormalizados);
      setIntermediariosError(interRes.status === "failed" ? interRes.error : null);
      setClientesError(cliRes.status === "failed" ? cliRes.error : null);
      setCargaError(null); // la carga cerró sin excepción → limpiar cualquier fatal previo

      // Diagnóstico visible + log completo de ambas respuestas (PARTE A).
      const nuevoDiag = {
        clientes: {
          status: cliRes.status,
          count: (cliRes.data || []).length,
          error: cliRes.error?.message || null,
        },
        intermediarios: {
          status: interRes.status,
          count: (interRes.data || []).length,
          error: interRes.error?.message || null,
        },
      };
      setDiag(nuevoDiag);
      // eslint-disable-next-line no-console
      console.log("[informes-comision] diagnóstico de carga base:", {
        pais,
        clientes: { ...nuevoDiag.clientes, respuesta: cliRes },
        intermediarios: { ...nuevoDiag.intermediarios, respuesta: interRes },
      });
      // Punto 3: SIN gracia. El estado (informe / vacío / error) se muestra de inmediato al terminar la
      // carga; mientras hay una carga en curso isLoading es true → nunca se ve vacío durante la carga.
      setIsLoading(false);
    } catch (err) {
      // Corrida obsoleta → no pisar el estado de una más nueva.
      if (myRun !== runIdRef.current) return;
      // EL CATCH YA NO ES MUDO (10.177). Antes: `catch {}` sin log/estado → una excepción acá dejaba
      // isLoading=false, clientes/intermediarios [] y diag=null → se veía como "no hay datos" (falso).
      // Ahora: log COMPLETO con stack + se guarda el error y se muestra como FALLO DE CARGA con el
      // mensaje real. Candidatos de throw (los 3 loaders son async → no lanzan sincrónico): la
      // normalización `.map` sobre un elemento null/no-objeto, o un import undefined. El mensaje+stack
      // de acá identifica cuál en la próxima carga.
      // eslint-disable-next-line no-console
      console.error("[informes-comision] EXCEPCIÓN en fetchData (antes se tragaba en silencio):", err, err?.stack);
      setCargaError(err instanceof Error ? err : new Error(String(err?.message ?? err)));
      setIsLoading(false);
    }
  }, [authLoading, pais, isDemoMode]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // const calcularPantallasAjustadas = (edificio, factura) => {
  //   const { pantallas_ascensores, pantallas_espera, pantallas_circulacion, pantallas_cowork } = factura;
  //   const edificioId = edificio.id.toString();

  //   if (!pantallas_ascensores && !pantallas_espera && !pantallas_circulacion && !pantallas_cowork) {
  //     return (edificio.pantallas || 0) + (edificio.espera || 0) + (edificio.totems || 0) + (edificio.cowork || 0);
  //   }

  //   let totalPantallas = 0;
  //   if (pantallas_ascensores && pantallas_ascensores.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.pantallas || 0;
  //   }
  //   if (pantallas_espera && pantallas_espera.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.espera || 0;
  //   }
  //   if (pantallas_circulacion && pantallas_circulacion.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.totems || 0;
  //   }
  //   if (pantallas_cowork && pantallas_cowork.split(",").includes(edificioId)) {
  //     totalPantallas += edificio.cowork || 0;
  //   }
  //   return totalPantallas;
  // };

  const onSubmit = useCallback(
    async (data) => {
      setIsLoading(true);
      try {
        setFacturas(null);
        let listaFacturas = [];
        let ventasBTL = [];

        const fechaInicioDate = new Date(data.fechaInicio);
        const fechaFinDate = new Date(data.fechaFin);
        if (isNaN(fechaInicioDate) || isNaN(fechaFinDate)) {
          throw new Error("Fechas inválidas");
        }

        const anoInicio = fechaInicioDate.getFullYear();
        const anoFin = fechaFinDate.getFullYear();
        const anos = [...new Set([anoInicio, anoFin])];

        // Recaudada por la VERDAD de cobro real (getCobroReal, 4 caminos), NO el `facturafechacobro`
        // crudo de la venta (que el cobro SII nunca puebla → Bug B). Overlay por venta sobre sales y
        // sales_contratos (por mes, contrato_id+mes_index). BTL fuera de alcance.
        const cobroPorVenta = await cargarCobroPorVenta(pais).catch(() => new Map());
        const overlayRecaudacion = (facturas) => {
          for (const f of facturas || []) {
            if (f.isBTL) continue;
            const key = f.isContrato ? `sales_contratos:${f.contrato_id}:${f.mes_index}` : `sales:${f.id}:`;
            const cobro = cobroPorVenta.get(key);
            f.facturafechacobro = cobro?.cobrada ? cobro.fecha || f.facturafecha : null;
          }
          return facturas;
        };

        const btlPromises = anos.map((ano) => getOportunidadesBTL({ pais, ano }).catch(() => []));
        const btlResults = await Promise.all(btlPromises);
        const btlData = btlResults.flat();

        const uniqueBTLSales = new Map();
        btlData
          .filter((sale) => {
            const facturaFecha = new Date(sale.facturafecha);
            const isValidDate = !isNaN(facturaFecha.getTime());
            if (!isValidDate) return false;
            const buildings = sale.buildings
              ? typeof sale.buildings === "string"
                ? JSON.parse(sale.buildings)
                : sale.buildings
              : [];
            const edificioIds = buildings.map((b) => b.id);
            return (
              sale.pais === pais &&
              !sale.eliminada &&
              facturaFecha >= fechaInicioDate &&
              facturaFecha <= fechaFinDate &&
              (data.edificio === "todos" ||
                edificioIds.includes(Number(data.edificio)) ||
                (esSeleccionSocio(data.edificio) &&
                  todosEdificios.some(
                    (ed) => edificioTuvoSocio(ed.id, socioIdSel(data.edificio)) && edificioIds.includes(ed.id)
                  )))
            );
          })
          .forEach((sale) => {
            if (!uniqueBTLSales.has(sale.id)) {
              const buildings = sale.buildings
                ? typeof sale.buildings === "string"
                  ? JSON.parse(sale.buildings)
                  : sale.buildings
                : [];
              const edificioData = buildings.find((b) => b.id === Number(data.edificio)) || buildings[0];
              const cliente = clientes.find((c) => c.id === sale.client_id && c.pais === pais);
              const clienteNombre = cliente ? cliente.nombre : "SIN CLIENTE";
              uniqueBTLSales.set(sale.id, {
                id: sale.id,
                facturanumero: sale.facturanumero || "-",
                facturafecha: sale.facturafecha,
                facturafechacobro: sale.facturafechacobro,
                cliente: clienteNombre,
                importe: edificioData ? edificioData.importe : 0,
                comision: edificioData ? edificioData.comision : 0,
                edificiosUnicos: buildings.length,
                pantallastotales: 0,
                isBTL: true,
                client_id: sale.client_id,
                buildings,
              });
            }
          });
        ventasBTL = [...uniqueBTLSales.values()];

        if (investmentType === "solo-btl" && ventasBTL.length === 0) {
          toast.error("No hay ventas BTL para los criterios seleccionados.");
        }

        const btlContributions = new Map();
        if (investmentType !== "solo-pauta") {
          ventasBTL.forEach((sale) => {
            const rateBTL = getRateForOpp(sale, getDolarValue, dolarFallback[pais]);
            sale.buildings.forEach((building) => {
              const edificioId = building.id;
              if (!btlContributions.has(edificioId)) {
                btlContributions.set(edificioId, { totalFacturadoBTL: 0, netoFacturadoBTL: 0, comisionGeneradaBTL: 0 });
              }
              const contrib = btlContributions.get(edificioId);
              const importeLocal = sale.moneda_dolar ? building.importe * rateBTL : building.importe;
              contrib.totalFacturadoBTL += importeLocal;
              contrib.netoFacturadoBTL += importeLocal;
              const edificio = todosEdificios.find((e) => e.id === edificioId);
              if (edificio) {
                const edificiosMapTemp = { [edificioId]: edificio };
                let comisionBTL = calcularComisionEdificiosTotal(sale, edificiosMapTemp, importeLocal);
                if (sale.moneda_dolar) comisionBTL = comisionBTL * rateBTL;
                contrib.comisionGeneradaBTL += comisionBTL;
              }
            });
          });
        }

        // Cargar contratos y explotar meses en facturas
        const edificiosMap = todosEdificios.reduce((acc, e) => {
          if (e.id) acc[e.id] = e;
          return acc;
        }, {});
        let facturasContratos = [];
        if (investmentType !== "solo-btl") {
          const contratosData = await getContratos({ pais }).catch(() => []);
          facturasContratos = explodarContratosComoFacturas(
            contratosData,
            edificiosMap,
            data.fechaInicio,
            data.fechaFin
          );
          overlayRecaudacion(facturasContratos);
        }

        // Helper: calcula resumen de comisiones para un grupo de edificios (usado en modo "todos" y "dueño").
        // `socioFiltroId` (Fase 2): si viene, una factura/BTL cuenta para el edificio SOLO si el dueño
        // vigente en su `facturafecha` (edificio_socio_historial) es ese socio — atribución fina por fecha,
        // no por el valor actual de alianza. NULL → sin filtro (modo "Todos").
        const calcularResumenEdificios = async (edificiosGrupo, socioFiltroId = null) => {
          // Predicado de pertenencia por fecha (10.177: si no hay historial que cubra la fecha, se
          // loggea y se excluye — no se atribuye a ciegas ni se omite en silencio).
          const perteneceAlSocio = (edificioId, facturafecha) => {
            if (socioFiltroId == null) return true;
            const sid = socioEnFecha(historialPorEdificio, edificioId, facturafecha);
            if (sid == null) {
              console.warn("[SOCIO_SIN_HISTORIAL]", { edificioId, facturafecha });
              return false;
            }
            return sid === socioFiltroId;
          };
          let facturasList = [];
          if (investmentType !== "solo-btl") {
            facturasList = await getFacturasComisionTodos({
              edificios: edificiosGrupo.map((ed) => ed.id),
              fechas: [data.fechaInicio, data.fechaFin],
              pais,
            });
            facturasList = facturasList.map((f) => ({ ...f, isBTL: false }));
            overlayRecaudacion(facturasList);
            facturasList = [...facturasList, ...facturasContratos];
          }

          if (facturasList.length === 0 && btlContributions.size === 0) {
            return [];
          }

          return edificiosGrupo
            .map((edificio) => {
              const facturasEdificio =
                investmentType !== "solo-btl"
                  ? facturasList.filter(
                      (factura) =>
                        factura.edificiosparticipantes?.split(",").includes(edificio.id.toString()) &&
                        perteneceAlSocio(edificio.id, factura.facturafecha)
                    )
                  : [];

              const totalFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                // Fase 2: numerador y denominador de la MISMA foto (resolverDesgloseComision).
                const desg = resolverDesgloseComision(factura, edificio, snapMap);
                const proporcionPantallas = desg.denominador > 0 ? desg.numerador / desg.denominador : 0;
                const rateFactura = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const importeFactura = getConvertedImporte(factura, rateFactura);
                return total + proporcionPantallas * importeFactura;
              }, 0);

              const netoFacturadoFacturas = facturasEdificio.reduce((total, factura) => {
                // Fase 2: numerador y denominador de la MISMA foto (resolverDesgloseComision).
                const desg = resolverDesgloseComision(factura, edificio, snapMap);
                const proporcionPantallas = desg.denominador > 0 ? desg.numerador / desg.denominador : 0;
                const neto = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais, pctMap);
                // FASE 6: take programático (USD nativo) baja la base; 0 si no hay costos / es contrato.
                const takeUsd = factura.isContrato ? 0 : costosMap?.get(`sales:${factura.id}`) || 0;
                const apxUsd = getApxMonto(factura, intermediarios, pctMap); // APX: sales Y contratos (gating por apx_id)
                const netoConTake = Math.max(0, neto - takeUsd - apxUsd);
                const rateNeto = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const netoConvertido = factura.moneda_dolar ? netoConTake * rateNeto : netoConTake;
                return total + proporcionPantallas * netoConvertido;
              }, 0);

              const comisionGeneradaFacturas = facturasEdificio.reduce((total, factura) => {
                const netoFactura = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais, pctMap);
                const takeUsd = factura.isContrato ? 0 : costosMap?.get(`sales:${factura.id}`) || 0;
                const apxUsd = getApxMonto(factura, intermediarios, pctMap); // APX: sales Y contratos (gating por apx_id)
                const edificiosMapTemp = { [edificio.id]: edificio };
                const comisionFactura = calcularComisionEdificiosTotal(
                  factura,
                  edificiosMapTemp,
                  netoFactura,
                  snapMap,
                  takeUsd,
                  apxUsd
                );
                const rateComision = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const comisionConvertida = factura.moneda_dolar ? comisionFactura * rateComision : comisionFactura;
                return total + comisionConvertida;
              }, 0);

              const btlContribZero = { totalFacturadoBTL: 0, netoFacturadoBTL: 0, comisionGeneradaBTL: 0 };
              // BTL generada/neto/total viene pre-agregado por edificio (sin fecha). Con filtro de socio:
              // si el edificio tuvo UN solo dueño, el pre-agregado es correcto; si cambió de dueño (>1 fila),
              // no es atribuible finamente → se excluye con traza (10.177). Hoy ningún edificio con cambio
              // de dueño tiene BTL, así que esto no resta plata real; queda como candado si algún día lo tiene.
              const btlContrib = (() => {
                const base = btlContributions.get(edificio.id) || btlContribZero;
                if (socioFiltroId == null) return base;
                const rows = historialPorEdificio.get(Number(edificio.id)) || [];
                if (rows.length <= 1) return base;
                console.warn("[SOCIO_BTL_MULTIDUENO]", { edificioId: edificio.id });
                return btlContribZero;
              })();

              const comisionRecaudadaFacturas = facturasEdificio.reduce((total, factura) => {
                // Corte pre-2026 (mismo predicado que ListadoFacturas:147, vista individual): cobro real
                // O facturación anterior al 2026-01-01 (cobro real recién se registra desde 2026; antes se
                // asume cobrado). Alinea el path grupo/"Todos"/alianza con la vista individual.
                if (!((factura.facturafecha && factura.facturafecha < "2026-01-01") || factura.facturafechacobro))
                  return total;
                const netoFactura = calcularImporteNetoIntermediario(factura, clientes, intermediarios, pais, pctMap);
                const takeUsd = factura.isContrato ? 0 : costosMap?.get(`sales:${factura.id}`) || 0;
                const apxUsd = getApxMonto(factura, intermediarios, pctMap); // APX: sales Y contratos (gating por apx_id)
                const edificiosMapTemp = { [edificio.id]: edificio };
                const comisionFactura = calcularComisionEdificiosTotal(
                  factura,
                  edificiosMapTemp,
                  netoFactura,
                  snapMap,
                  takeUsd,
                  apxUsd
                );
                const rateComision = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                return total + (factura.moneda_dolar ? comisionFactura * rateComision : comisionFactura);
              }, 0);

              const comisionRecaudadaBTL = ventasBTL
                // Corte pre-2026 (mismo predicado que ListadoFacturas:147): cobro real O facturación < 2026-01-01.
                .filter(
                  (s) =>
                    ((s.facturafecha && s.facturafecha < "2026-01-01") || s.facturafechacobro) &&
                    (s.buildings || []).some((b) => b.id === edificio.id) &&
                    perteneceAlSocio(edificio.id, s.facturafecha)
                )
                .reduce((t, s) => {
                  const building = (s.buildings || []).find((b) => b.id === edificio.id);
                  if (!building) return t;
                  const rateBTL = getRateForOpp(s, getDolarValue, dolarFallback[pais]);
                  const importeLocal = s.moneda_dolar ? building.importe * rateBTL : building.importe;
                  const edificiosMapTemp = { [edificio.id]: edificio };
                  let comBTL = calcularComisionEdificiosTotal(s, edificiosMapTemp, importeLocal);
                  if (s.moneda_dolar) comBTL *= rateBTL;
                  return t + comBTL;
                }, 0);

              return {
                edificioId: edificio.id,
                edificio: edificio.edificio,
                totalFacturado: totalFacturadoFacturas + btlContrib.totalFacturadoBTL,
                netoFacturado: netoFacturadoFacturas + btlContrib.netoFacturadoBTL,
                comisionGenerada: comisionGeneradaFacturas + btlContrib.comisionGeneradaBTL,
                comisionRecaudada: comisionRecaudadaFacturas + comisionRecaudadaBTL,
              };
            })
            .filter(
              (resumen) => resumen.totalFacturado > 0 || resumen.netoFacturado > 0 || resumen.comisionGenerada > 0
            );
        };

        if (data.edificio === "todos") {
          setFacturas(await calcularResumenEdificios(todosEdificios));
        } else if (esSeleccionSocio(data.edificio)) {
          // Grupo por DUEÑO: consideramos los edificios que pertenecieron a ese dueño en ALGÚN momento
          // (para no perder los que cambiaron), y la atribución fina por factura la hace socioFiltroId.
          const socioId = socioIdSel(data.edificio);
          const edificiosGrupo = todosEdificios.filter((edificio) => edificioTuvoSocio(edificio.id, socioId));
          setFacturas(await calcularResumenEdificios(edificiosGrupo, socioId));
        } else {
          const edificio = todosEdificios.find((ed) => ed.id === Number(data.edificio));
          if (!edificio) {
            setFacturas([]);
            return;
          }

          if (investmentType !== "solo-btl") {
            listaFacturas = await getFacturasComision2({
              edificio: data.edificio,
              fechas: [data.fechaInicio, data.fechaFin],
              pais,
            });
            overlayRecaudacion(listaFacturas);

            listaFacturas = listaFacturas.map((factura) => {
              const importeNetoTotal = calcularImporteNetoIntermediario(
                factura,
                clientes,
                intermediarios,
                pais,
                pctMap
              );
              const comisionPorcentaje = calcularPorcentajeComisionIntermediario(
                factura,
                clientes,
                intermediarios,
                pais,
                pctMap
              );
              const intermediarioNombre = obtenerNombreIntermediario(factura, clientes, intermediarios, pais);

              // Pantallas y participación de la MISMA foto que la comisión (Fase 2, resolverDesgloseComision):
              // numerador y denominador salen de la misma foto, nunca vivo ÷ congelado.
              const desg = resolverDesgloseComision(factura, edificio, snapMap);
              const pantallasAjustadas = desg.numerador;
              const denomFactura = desg.denominador;
              const participacion = denomFactura > 0 ? pantallasAjustadas / denomFactura : 0;

              // Neto proporcional al edificio (esto es lo que queremos mostrar). FASE 6: el take
              // programático (USD nativo) baja la base antes del prorrateo; 0 si no hay costos.
              const takeUsd = factura.isContrato ? 0 : costosMap?.get(`sales:${factura.id}`) || 0;
              const apxUsd = getApxMonto(factura, intermediarios, pctMap); // APX: sales Y contratos (gating por apx_id)
              const importeNetoProporcional = participacion * Math.max(0, importeNetoTotal - takeUsd - apxUsd);

              // Convertir USD → moneda local si corresponde
              const rate = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
              const importeNetoFinal = factura.moneda_dolar ? importeNetoProporcional * rate : importeNetoProporcional;
              const importeBrutoFinal = factura.moneda_dolar ? factura.importe * rate : factura.importe;

              // APX: el % mostrado compone agencia% + apx% (10+9=19) SI apx_id; sin apx_id → solo
              // agencia% (idéntico a hoy). Display-side, no toca el motor de %. Ratio independiente de moneda.
              const apxPct = factura.importe > 0 ? (apxUsd / factura.importe) * 100 : 0;
              return {
                ...factura,
                intermediario: intermediarioNombre,
                comision: comisionPorcentaje + apxPct,
                importeNeto: importeNetoFinal,
                importe: importeBrutoFinal,
                isBTL: false,
                // Venta CRUDA preservada para el modal de detalle (importe bruto + moneda_dolar
                // originales). El modal re-deriva neto/comisión para TODOS los edificios.
                __rawSale: factura,
              };
            });

            // Agregar facturas de contratos filtradas por este edificio
            const contratosEdificio = facturasContratos
              .filter((f) => f.edificiosparticipantes?.split(",").includes(String(data.edificio)))
              .map((factura) => {
                const importeNetoTotal = calcularImporteNetoIntermediario(
                  factura,
                  clientes,
                  intermediarios,
                  pais,
                  pctMap
                );
                const comisionPorcentaje = calcularPorcentajeComisionIntermediario(
                  factura,
                  clientes,
                  intermediarios,
                  pais,
                  pctMap
                );
                const intermediarioNombre = obtenerNombreIntermediario(factura, clientes, intermediarios, pais);
                const clienteRef = clientes.find((c) => c.id === factura.client_id && c.pais === pais);
                const clienteNombre = clienteRef
                  ? clienteRef.empresa === clienteRef.producto
                    ? clienteRef.nombre
                    : `${clienteRef.empresa} | ${clienteRef.producto}`
                  : "SIN CLIENTE";
                // Fase 2: numerador y denominador de la MISMA foto (resolverDesgloseComision).
                const desg = resolverDesgloseComision(factura, edificio, snapMap);
                const pantallasAjustadas = desg.numerador;
                const denomContrato = desg.denominador;
                const proporcion = denomContrato > 0 ? pantallasAjustadas / denomContrato : 0;
                // APX en contratos (apx_id a nivel contrato, importe del mes). Baja la base del neto
                // proporcional igual que en sales; gating por apx_id (0 si no hay). take=0 en contratos.
                const apxUsd = getApxMonto(factura, intermediarios, pctMap);
                const importeNetoProporcional = proporcion * Math.max(0, importeNetoTotal - apxUsd);

                // Convertir USD → moneda local si corresponde
                const rateContrato = getRateForOpp(factura, getDolarValue, dolarFallback[pais]);
                const netoFinal = factura.moneda_dolar
                  ? importeNetoProporcional * rateContrato
                  : importeNetoProporcional;
                const brutoFinal = factura.moneda_dolar ? factura.importe * rateContrato : factura.importe;
                const apxPct = factura.importe > 0 ? (apxUsd / factura.importe) * 100 : 0;

                return {
                  ...factura,
                  cliente: clienteNombre,
                  intermediario: intermediarioNombre,
                  comision: comisionPorcentaje + apxPct,
                  importeNeto: netoFinal,
                  importe: brutoFinal,
                  isBTL: false,
                  // Contrato-factura CRUDO preservado para el modal de detalle (ver nota arriba).
                  __rawSale: factura,
                };
              });
            listaFacturas = [...listaFacturas, ...contratosEdificio];
          } else {
            listaFacturas = [];
          }

          const btlFiltradasSet = new Set();
          const btlFiltradas =
            investmentType !== "solo-pauta"
              ? ventasBTL.filter((sale) => {
                  const isRelevant = (sale.buildings || []).some((b) => b.id === Number(data.edificio));
                  if (isRelevant && !btlFiltradasSet.has(sale.id)) {
                    btlFiltradasSet.add(sale.id);
                    return true;
                  }
                  return false;
                })
              : [];

          const combinedListado = [
            ...(investmentType !== "solo-btl" ? listaFacturas : []),
            ...(investmentType !== "solo-pauta" ? btlFiltradas : []),
          ];

          if (combinedListado.length === 0) {
            setFacturas([]);
            return;
          }

          const newFacturas = {
            comisionEdificio_1_porcentaje: edificio.comision_1_porcentaje,
            comisionEdificio_1_fechainicio: edificio.comision_1_fechainicio,
            comisionEdificio_1_fechafin: edificio.comision_1_fechafin,
            comisionEdificio_2_porcentaje: edificio.comision_2_porcentaje,
            comisionEdificio_2_fechainicio: edificio.comision_2_fechainicio,
            comisionEdificio_2_fechafin: edificio.comision_2_fechafin,
            comisionEdificio_3_porcentaje: edificio.comision_3_porcentaje,
            comisionEdificio_3_fechainicio: edificio.comision_3_fechainicio,
            comisionEdificio_3_fechafin: edificio.comision_3_fechafin,
            listado: combinedListado,
            // TOTAL FÍSICO del edificio (los 4 circuitos), NO el numerador del prorrateo: es un dato de
            // referencia del inventario del edificio, distinto de `resolverDesgloseComision().numerador`
            // (que filtra por los CSV de circuitos de cada venta). En ListadoFacturas solo se usa como
            // default cuando no hay `edificioId` específico; con edificioId (siempre, acá) manda la foto.
            pantallasEdificio: edificio.pantallas + edificio.totems + edificio.espera + edificio.cowork,
            edificioId: edificio.id,
          };
          setFacturas(newFacturas);
        }
      } catch (error) {
        log.error("CalculadorComisionEdificio", error);
        toast.error(`Error al procesar el informe: ${error.message}`);
        setFacturas([]);
      } finally {
        setIsLoading(false);
      }
    },
    [
      todosEdificios,
      intermediarios,
      pais,
      clientes,
      investmentType,
      getDolarValue,
      dolarFallback,
      snapMap,
      pctMap,
      costosMap,
      historialPorEdificio,
      esSeleccionSocio,
      socioIdSel,
      edificioTuvoSocio,
    ]
  );

  const forceSubmit = useCallback(() => {
    if (intermediarios.length === 0 || clientes.length === 0 || todosEdificios.length === 0) {
      return;
    }
    handleSubmit(onSubmit)();
  }, [handleSubmit, onSubmit, intermediarios, clientes, todosEdificios]);

  useEffect(() => {
    if (isDemoMode) return;
    const initialize = async () => {
      setIsLoading(true);
      try {
        const newEdificios = await getEdificiosOperativos({ pais });
        newEdificios.sort((a, b) => a.edificio.localeCompare(b.edificio));
        const edificiosFiltrados = newEdificios.filter((ed) => !EDIFICIOS_EXCLUIDOS.includes(ed.id));
        setEdificiosFull(edificiosFiltrados);
        const todos = !edificiosOk
          ? edificiosFiltrados
          : edificiosFiltrados.filter((edificio) => edificiosOk.includes(edificio.id));
        setTodosEdificios(todos);
        // Fase 2: catálogo de dueños + historial por edificio (agrupación por dueño-en-fecha).
        const { socios: sociosData, historialPorEdificio: histMap } = await cargarHistorialSocios(pais);
        setSocios(sociosData);
        setHistorialPorEdificio(histMap);
      } catch (error) {
        toast.error(`Error al inicializar edificios: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };
    initialize();
  }, [pais, edificiosOk, isDemoMode]);

  useEffect(() => {
    const currentFormValues = { edificio: edificioSeleccionado, fechaInicio, fechaFin, investmentType };
    const hasChanged = JSON.stringify(currentFormValues) !== JSON.stringify(lastFormValues.current);
    if (
      edificioSeleccionado !== "0" &&
      regexFecha.test(fechaInicio) &&
      regexFecha.test(fechaFin) &&
      intermediarios.length > 0 &&
      clientes.length > 0 &&
      todosEdificios.length > 0 &&
      ratesLoaded &&
      hasChanged &&
      !isLoading
    ) {
      lastFormValues.current = currentFormValues;
      forceSubmit();
    }
  }, [
    forceSubmit,
    edificioSeleccionado,
    fechaInicio,
    fechaFin,
    investmentType,
    intermediarios,
    clientes,
    todosEdificios,
    isLoading,
    ratesLoaded,
  ]);

  // Pagos al edificio — Fase 2: la PAGADA sale de las APLICACIONES registradas a mano
  // (aplicacion_pago_comision_edificio), NO de la suma plana de movimientos_caja por entidad_id.
  // Se filtra por edificio + socio (cuando el grupo es un dueño con alianza) o por edificio directo
  // (individual / sin alianza → socio_id NULL). Un pago sin aplicar NO aparece bajo ningún dueño.
  // `getSaldoEdificio` (histórico whole-history) no se toca — sigue para la liquidación.
  useEffect(() => {
    if (
      !pais ||
      !edificioSeleccionado ||
      edificioSeleccionado === "0" ||
      !regexFecha.test(fechaInicio) ||
      !regexFecha.test(fechaFin) ||
      todosEdificios.length === 0
    ) {
      setPagosEdificio([]);
      return;
    }

    const resolverIds = () => {
      if (edificioSeleccionado === "todos") return todosEdificios.map((e) => e.id);
      if (esSeleccionSocio(edificioSeleccionado))
        return todosEdificios.filter((e) => edificioTuvoSocio(e.id, socioIdSel(edificioSeleccionado))).map((e) => e.id);
      return [Number(edificioSeleccionado)];
    };

    const ids = resolverIds();
    if (ids.length === 0) {
      setPagosEdificio([]);
      return;
    }

    const socioFiltro = esSeleccionSocio(edificioSeleccionado) ? socioIdSel(edificioSeleccionado) : null;
    let cancelled = false;
    (async () => {
      try {
        let q = client
          .from("aplicacion_pago_comision_edificio")
          .select("id, movimiento_caja_id, edificio_id, socio_id, periodo, monto_neto")
          .in("edificio_id", ids);
        if (socioFiltro != null) q = q.eq("socio_id", socioFiltro);
        const { data: aplic, error } = await q;
        if (error) throw error;
        // Fecha del pago (para la cartola por mes) desde movimientos_caja de esas aplicaciones.
        const movIds = [...new Set((aplic || []).map((a) => a.movimiento_caja_id))];
        let fechaByMov = {};
        if (movIds.length > 0) {
          const { data: movs } = await client.from("movimientos_caja").select("id, fecha").in("id", movIds);
          fechaByMov = Object.fromEntries((movs || []).map((m) => [m.id, m.fecha]));
        }
        const rows = (aplic || []).map((a) => ({
          id: a.id,
          monto: Number(a.monto_neto || 0),
          fecha: fechaByMov[a.movimiento_caja_id] || `${a.periodo}-01`,
          periodo: a.periodo,
          socio_id: a.socio_id,
          edificio_id: a.edificio_id,
        }));
        if (!cancelled) setPagosEdificio(rows);
      } catch (e) {
        console.error("pagosEdificio (aplicaciones):", e);
        if (!cancelled) setPagosEdificio([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [
    pais,
    edificioSeleccionado,
    fechaInicio,
    fechaFin,
    todosEdificios,
    historialPorEdificio,
    esSeleccionSocio,
    socioIdSel,
    edificioTuvoSocio,
  ]);

  // Histórico no bloqueante: corre en paralelo al onSubmit, dispara cuando cambia edificio o pais.
  // Solo modo individual por ahora. Reusa la pipeline de cálculo de comisión sin filtro de fechas.
  useEffect(() => {
    if (
      !pais ||
      !edificioSeleccionado ||
      edificioSeleccionado === "0" ||
      todosEdificios.length === 0 ||
      intermediarios.length === 0 ||
      clientes.length === 0 ||
      !ratesLoaded
    ) {
      setHistorico({
        bruto: null,
        neto: null,
        comisionIntermediario: null,
        generada: null,
        recaudada: null,
        movimientos: [],
        loading: false,
      });
      return;
    }

    const esIndividual = edificioSeleccionado !== "todos" && !esSeleccionSocio(edificioSeleccionado);
    if (!esIndividual) return;

    const edificio = todosEdificios.find((e) => e.id === Number(edificioSeleccionado));
    if (!edificio) return;

    setHistorico((prev) => ({ ...prev, loading: true }));

    let cancelled = false;
    (async () => {
      try {
        // Fuente única de verdad: motor extraído a getSaldoEdificio. Mismo cálculo que antes vivía
        // inline acá (generada/recaudada históricas [2023-01-01 … hoy]). El saldo a pagar se sigue
        // derivando en el render como recaudada − pagada (pagadaHistorico de pagosEdificio).
        const r = await getSaldoEdificio({ pais, edificioId: edificio.id });

        if (!cancelled) {
          setHistorico({
            bruto: r.bruto,
            neto: r.neto,
            comisionIntermediario: r.comisionIntermediario,
            generada: r.generada,
            recaudada: r.recaudada,
            movimientos: r.movimientos || [],
            loading: false,
          });
        }
      } catch (err) {
        console.error("[historico] error:", err);
        if (!cancelled) setHistorico((prev) => ({ ...prev, loading: false }));
      }
    })();
    return () => {
      cancelled = true;
    };
    // getDolarValue y dolarFallback se capturan por closure y son referencias inestables
    // (no memoizadas en useExchangeRates). Incluirlas en deps causa re-render loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edificioSeleccionado, pais, todosEdificios, intermediarios, clientes, ratesLoaded]);

  const demoMoneda = pais === "Perú" ? "S/ " : "$ ";
  const demoLocale = pais === "Perú" ? "es-PE" : "es-CL";
  const demoDecimales = pais === "Perú" ? 2 : 0;
  const demoEquipo = pais === "Perú" ? "Visiona" : "Wecast";
  const fmt = (n) =>
    `${demoMoneda}${n.toLocaleString(demoLocale, {
      minimumFractionDigits: demoDecimales,
      maximumFractionDigits: demoDecimales,
    })}`;

  // Edificios de Visiona/Perú: mensaje de mantenimiento en vez del reporte (antes de isDemoMode).
  if (bloqueadoEdificioPeru) {
    return (
      <div className="CalculadorComisionEdificio">
        <Header />
        <div style={{ display: "flex", justifyContent: "center", padding: "48px 16px" }}>
          <div
            style={{
              maxWidth: 620,
              width: "100%",
              background: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              padding: "36px 40px",
              textAlign: "center",
            }}
          >
            <h3 style={{ margin: "0 0 20px", color: "#1e3a5f", fontWeight: 700 }}>Estamos mejorando para ustedes</h3>
            <p style={{ margin: "0 0 16px", fontSize: "0.98rem", color: "#374151", lineHeight: 1.6 }}>
              En Visiona estamos comprometidos con la excelencia. Nuestro equipo técnico se encuentra auditando y
              optimizando el módulo de reportes para asegurar la máxima exactitud en cada detalle.
            </p>
            <p style={{ margin: "0 0 16px", fontSize: "0.98rem", color: "#374151", lineHeight: 1.6 }}>
              Mientras tanto, por favor conectate con <strong>Priscila Munguía</strong>, quien estará compartiendo
              directamente con cada edificio la información y los reportes solicitados.
            </p>
            <p style={{ margin: 0, fontSize: "0.98rem", color: "#374151", lineHeight: 1.6 }}>
              Gracias por su confianza y paciencia durante esta etapa de mejora continua.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isDemoMode) {
    const mul = pais === "Perú" ? 1 : 1000;
    const demoConsolidado = [
      {
        edificio: "Edificio A",
        totalFacturado: 28500 * mul,
        netoFacturado: 24225 * mul,
        comisionGenerada: 3634 * mul,
      },
      {
        edificio: "Edificio B",
        totalFacturado: 19200 * mul,
        netoFacturado: 16320 * mul,
        comisionGenerada: 2448 * mul,
      },
      {
        edificio: "Edificio C",
        totalFacturado: 12800 * mul,
        netoFacturado: 10880 * mul,
        comisionGenerada: 1632 * mul,
      },
    ];

    const totalBruto = demoConsolidado.reduce((t, r) => t + r.totalFacturado, 0);
    const totalNeto = demoConsolidado.reduce((t, r) => t + r.netoFacturado, 0);
    const totalComision = demoConsolidado.reduce((t, r) => t + r.comisionGenerada, 0);

    const demoFacturas = [
      {
        tipo: "PAUTA",
        numero: "F-2025-0412",
        fecha: "15/01/25",
        cliente: "Cliente Ejemplo 1",
        pantallas: 42,
        share: "28.6%",
        bruto: 12000 * mul,
        intermediario: "DIRECTO",
        comPct: "-",
        neto: 12000 * mul,
        comEdPct: "15%",
        comEd: 1800 * mul,
        cobrada: true,
      },
      {
        tipo: "PAUTA",
        numero: "F-2025-0455",
        fecha: "01/02/25",
        cliente: "Cliente Ejemplo 2",
        pantallas: 42,
        share: "28.6%",
        bruto: 9500 * mul,
        intermediario: "Agencia Demo",
        comPct: "15%",
        neto: 8075 * mul,
        comEdPct: "15%",
        comEd: 1211 * mul,
        cobrada: true,
      },
      {
        tipo: "BTL",
        numero: "BTL-2025-018",
        fecha: "20/02/25",
        cliente: "Cliente Ejemplo 3",
        pantallas: "-",
        share: "-",
        bruto: 3500 * mul,
        intermediario: "DIRECTO",
        comPct: "-",
        neto: 3500 * mul,
        comEdPct: "15%",
        comEd: 525 * mul,
        cobrada: false,
      },
      {
        tipo: "PAUTA",
        numero: "F-2025-0501",
        fecha: "10/03/25",
        cliente: "Cliente Ejemplo 1",
        pantallas: 42,
        share: "28.6%",
        bruto: 3500 * mul,
        intermediario: "DIRECTO",
        comPct: "-",
        neto: 3500 * mul,
        comEdPct: "15%",
        comEd: 525 * mul,
        cobrada: false,
      },
    ];

    const totalDetBruto = demoFacturas.reduce((t, f) => t + (typeof f.bruto === "number" ? f.bruto : 0), 0);
    const totalDetNeto = demoFacturas.reduce((t, f) => t + (typeof f.neto === "number" ? f.neto : 0), 0);
    const totalDetCom = demoFacturas.reduce((t, f) => t + (typeof f.comEd === "number" ? f.comEd : 0), 0);

    return (
      <div className="CalculadorComisionEdificio">
        <Header />

        <div
          style={{
            background: "#fff3cd",
            border: "1px solid #ffc107",
            borderRadius: 8,
            padding: "16px 24px",
            margin: "20px 0",
            fontSize: "0.95rem",
          }}
        >
          <strong>Usted no tiene edificios asignados.</strong> Por favor contacte al equipo {demoEquipo} para su
          vinculación.
        </div>

        <div style={{ opacity: 0.85 }}>
          <p style={{ marginTop: 20, marginBottom: 16, fontSize: "0.95rem" }}>
            A continuación le compartimos una vista consolidada como ejemplo de cómo se liquidan las comisiones.
          </p>
          <h5 style={{ marginBottom: 12 }}>Vista Consolidada (ejemplo)</h5>
          <table className="table table-success table-bordered table-custom table-totales">
            <thead>
              <tr className="total-row">
                <td className="text-start">TOTALES</td>
                <td className="text-end">{fmt(totalBruto)}</td>
                <td className="text-end">{fmt(totalNeto)}</td>
                <td className="text-end">{fmt(totalComision)}</td>
                <td className="text-center">100%</td>
              </tr>
            </thead>
          </table>
          <table className="table table-striped table-bordered table-hover table-custom table-detalles">
            <thead className="text-center align-middle">
              <tr>
                <th width="5%">#</th>
                <th width="25%">EDIFICIO</th>
                <th width="20%">FACTURACIÓN BRUTA</th>
                <th width="20%">FACTURACIÓN NETA</th>
                <th width="20%">COMISIÓN GENERADA</th>
                <th width="10%">%</th>
              </tr>
            </thead>
            <tbody>
              {demoConsolidado.map((r, i) => (
                <tr key={r.edificio}>
                  <td className="text-center">{i + 1}</td>
                  <td className="text-start uppercase">{r.edificio}</td>
                  <td className="text-end">{fmt(r.totalFacturado)}</td>
                  <td className="text-end">{fmt(r.netoFacturado)}</td>
                  <td className="text-end">{fmt(r.comisionGenerada)}</td>
                  <td className="text-center">{((r.comisionGenerada / totalComision) * 100).toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h5 style={{ marginTop: 32, marginBottom: 12 }}>Vista Detalle por Edificio (ejemplo — Edificio A)</h5>
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover table-custom">
              <thead className="text-center align-middle" style={{ background: "#343a40", color: "#fff" }}>
                <tr>
                  <th>TIPO</th>
                  <th>NRO FACTURA</th>
                  <th>FECHA FACTURA</th>
                  <th>CLIENTE</th>
                  <th>PANTALLAS</th>
                  <th>SHARE EDIFICIO</th>
                  <th>IMPORTE BRUTO</th>
                  <th>INTERMEDIARIO</th>
                  <th>COMISIÓN AGENCIA</th>
                  <th>IMPORTE NETO</th>
                  <th>COM. EDIFICIO %</th>
                  <th>COM. EDIFICIO $</th>
                  <th>COBRADA</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "0.8rem" }}>
                {demoFacturas.map((f) => (
                  <tr key={f.numero}>
                    <td className="text-center">{f.tipo}</td>
                    <td className="text-center">{f.numero}</td>
                    <td className="text-center">{f.fecha}</td>
                    <td>{f.cliente}</td>
                    <td className="text-center">{f.pantallas}</td>
                    <td className="text-center">{f.share}</td>
                    <td className="text-end">{fmt(f.bruto)}</td>
                    <td>{f.intermediario}</td>
                    <td className="text-center">{f.comPct}</td>
                    <td className="text-end">{fmt(f.neto)}</td>
                    <td className="text-center">{f.comEdPct}</td>
                    <td className="text-end">{fmt(f.comEd)}</td>
                    <td className="text-center">
                      <span style={{ color: f.cobrada ? "green" : "red", fontWeight: 600 }}>
                        {f.cobrada ? "Sí" : "Pendiente"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot style={{ background: "#343a40", color: "#fff", fontWeight: 600, fontSize: "0.8rem" }}>
                <tr>
                  <td colSpan="6" className="text-start">
                    TOTALES
                  </td>
                  <td className="text-end">{fmt(totalDetBruto)}</td>
                  <td colSpan="2" />
                  <td className="text-end">{fmt(totalDetNeto)}</td>
                  <td />
                  <td className="text-end">{fmt(totalDetCom)}</td>
                  <td />
                </tr>
              </tfoot>
            </table>
          </div>

          <p style={{ fontStyle: "italic", color: "#666", marginTop: 16, fontSize: "0.85rem" }}>
            Los datos mostrados son ejemplos ilustrativos. Una vez asignados sus edificios, verá la información real de
            facturación y comisiones.
          </p>
        </div>
      </div>
    );
  }

  // Detalle de diagnóstico visible (PARTE A): cuántas filas devolvió cada consulta y su estado, para
  // que el cartel no sea mudo. Se muestra tal cual tanto en el bloque de vacío como en el de error.
  const diagLinea = diag ? (
    <p className="estado-carga-detalle">
      Clientes: {diag.clientes.count} ({ESTADO_CARGA_LABEL[diag.clientes.status] || diag.clientes.status}
      {diag.clientes.error ? `: ${diag.clientes.error}` : ""}). Intermediarios: {diag.intermediarios.count} (
      {ESTADO_CARGA_LABEL[diag.intermediarios.status] || diag.intermediarios.status}
      {diag.intermediarios.error ? `: ${diag.intermediarios.error}` : ""}).
    </p>
  ) : null;

  return (
    <div className="CalculadorComisionEdificio">
      {/* INVARIANTE (garantizado por estructura): la rama de ERROR de abajo solo es alcanzable cuando
          (1) el auth resolvió (!authLoading), (2) ninguna carga está en curso y (3) al menos una carga
          terminó CON una excepción/fallo real (intermediariosError/clientesError/cargaError). (2)+(3)
          los da `isLoading`, que arranca en true y solo pasa a false dentro de fetchData al terminar una
          carga. NO hay rama de "vacío": si clientes/intermediarios vienen [] sin error, se cae directo
          al render normal (informe con filtros) — nunca un cartel de "no hay datos". */}
      {authLoading || isLoading ? (
        <p>Cargando datos...</p>
      ) : isSafari() ? (
        <div className="safari-warning">
          <p>
            Este componente solo es compatible con Google Chrome. Por favor, utiliza Chrome para acceder a esta
            funcionalidad.
          </p>
        </div>
      ) : intermediariosError || clientesError || cargaError ? (
        // CASO "falló la carga": error real (red/auth) o EXCEPCIÓN en fetchData (cargaError, antes muda).
        // Una línea + el detalle en letra chica y el botón Reintentar (acá sí hay algo que reintentar).
        <div className="estado-carga">
          <p className="estado-carga-titulo">No se pudieron cargar los datos.</p>
          {cargaError && <p className="estado-carga-detalle">Excepción: {cargaError.message}</p>}
          {diagLinea}
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={fetchData}>
            Reintentar
          </button>
        </div>
      ) : (
        <>
          <Header
            leftContent={
              <div style={{ display: "flex", alignItems: "center", marginLeft: 150 }}>
                <div
                  style={{
                    display: "flex",
                    gap: 0,
                    borderRadius: 6,
                    overflow: "hidden",
                    border: "1px solid #dee2e6",
                  }}
                >
                  {[
                    { key: "comision", label: "Comisión" },
                    { key: "eecc", label: "EECC" },
                  ].map((v) => (
                    <button
                      key={v.key}
                      type="button"
                      onClick={() => setVistaActiva(v.key)}
                      style={{
                        padding: "6px 22px",
                        fontSize: "0.82rem",
                        fontWeight: 600,
                        border: "none",
                        cursor: "pointer",
                        background: vistaActiva === v.key ? "#2c3e50" : "transparent",
                        color: vistaActiva === v.key ? "#fff" : "#666",
                      }}
                    >
                      {v.label}
                    </button>
                  ))}
                </div>
              </div>
            }
          >
            <form className="filtros-container" onSubmit={handleSubmit(onSubmit)}>
              <div className="filtro-group">
                <label>1. Edificio o Alianza</label>
                <select className="form-select" {...register("edificio")}>
                  <option disabled value="0">
                    Selecciona una opción
                  </option>
                  {todosEdificios.length > 1 && <option value="todos">Todos</option>}
                  {socios.map((s) => (
                    <option key={s.id} value={`socio:${s.id}`}>
                      {s.nombre}
                    </option>
                  ))}
                  {todosEdificios.map((edificio) => (
                    <option key={edificio.id} value={edificio.id}>
                      {edificio.edificio}
                    </option>
                  ))}
                </select>
              </div>
              <div className="filtro-group">
                <label>2. Fecha de Inicio</label>
                <input type="date" className="form-control" {...register("fechaInicio")} />
              </div>
              <div className="filtro-group">
                <label>3. Fecha de Fin</label>
                <input type="date" className="form-control" {...register("fechaFin")} />
              </div>
              <div className="filtro-group">
                <label>4. Tipo de Inversión</label>
                <select
                  className="form-select"
                  value={investmentType}
                  onChange={(e) => setInvestmentType(e.target.value)}
                >
                  <option value="todas">Todas las Inversiones</option>
                  <option value="solo-pauta">Pauta publicitaria</option>
                  <option value="solo-btl">BTL</option>
                </select>
              </div>
            </form>
          </Header>

          {/* Banda: aviso de cifras dinámicas (no definitivas hasta la liquidación) */}
          <div
            style={{
              background: "#fff3cd",
              border: "1px solid #ffe69c",
              borderRadius: 6,
              padding: "10px 18px",
              margin: "16px 0 4px",
              fontSize: "0.82rem",
              color: "#664d03",
              textAlign: "center",
            }}
          >
            Estos montos reflejan el estado actual de las ventas y pueden registrar modificaciones, producto de
            revisiones o ajustes, hasta el momento de su liquidación.
          </div>

          {/* Tabs Variable / Fijos */}
          {pais === "Perú" && edificioSeleccionado !== "0" && fechaInicio && fechaFin && (
            <div style={{ display: "flex", gap: 0, margin: "12px 0 16px" }}>
              <button
                className={`btn ${activeTab === "variable" ? "btn-primary" : "btn-outline-secondary"}`}
                onClick={() => setActiveTab("variable")}
                style={{ borderRadius: "6px 0 0 6px" }}
              >
                Variable
              </button>
              <button
                className={`btn ${activeTab === "fijos" ? "btn-primary" : "btn-outline-secondary"}`}
                onClick={() => setActiveTab("fijos")}
                style={{ borderRadius: "0 6px 6px 0" }}
              >
                Fijos
              </button>
            </div>
          )}

          {/* ═══ BARRA KPIs ═══ */}
          {facturas &&
            (Array.isArray(facturas) ? facturas.length > 0 : facturas.listado?.length > 0) &&
            (() => {
              const fmtKpi = (n) =>
                n == null ? "—" : `${moneda(pais)}${Math.round(n).toLocaleString(localString(pais))}`;
              const pagadaHistorico = pagosEdificio.reduce((s, p) => s + Number(p.monto || 0), 0);
              const labelRecaudada = pais === "Chile" ? "Recaudada" : "Cobrada";

              const gridStyle = {
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                gap: 16,
                width: "90%",
                margin: "16px auto",
                padding: "14px 0",
              };
              const labelStyle = {
                fontSize: "0.75rem",
                fontWeight: 500,
                marginBottom: 5,
                paddingBottom: 5,
                borderBottom: "1px solid rgba(255,255,255,0.3)",
                opacity: 0.9,
                textTransform: "uppercase",
              };
              const valueStyle = { fontSize: "1.05rem", fontWeight: 700, marginTop: 5 };
              const headerSubtitleStyle = {
                gridColumn: "1 / -1",
                fontSize: "0.7rem",
                color: "#888",
                marginBottom: 2,
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              };
              const renderCard = (kpi, valueOverride) => (
                <div
                  key={kpi.label}
                  style={{
                    background: kpi.bg || "#343a40",
                    borderRadius: 6,
                    padding: "12px 24px",
                    textAlign: "center",
                    color: "#fff",
                    opacity: kpi.dim ? 0.5 : 1,
                  }}
                >
                  <div style={labelStyle}>{kpi.label}</div>
                  <div style={valueStyle}>{valueOverride ?? fmtKpi(kpi.valor)}</div>
                </div>
              );

              if (vistaActiva === "eecc") {
                const saldoEecc = historico.recaudada != null ? historico.recaudada - pagadaHistorico : null;
                const kpisEecc = [
                  { label: "Facturación Bruta", valor: historico.bruto },
                  { label: "Intermediación", valor: historico.comisionIntermediario, bg: "#854d0e" },
                  { label: "Facturación Neta", valor: historico.neto },
                  { label: "Com. Generada", valor: historico.generada, bg: "#1e40af" },
                  { label: labelRecaudada, valor: historico.recaudada, bg: "#5b21b6" },
                  { label: "Pagada", valor: pagadaHistorico, bg: "#166534" },
                  { label: "Saldo a Pagar", valor: saldoEecc, bg: "#991b1b" },
                ];
                // ── Cartola de cuenta corriente (Fase LÓGICA) ───────────────────────────────
                // Recaudado: de historico.movimientos (getSaldoEdificio). Apertura = lump pre-2026
                // (pre===true); meses 2026+ = comisión agrupada por facturafechacobro (mes de cobro
                // real). Pagos: REALES de pagosEdificio por mes. Saldo running arranca en el lump.
                // Aditivo: los totales de las cards NO cambian (regla 10.73 / P2.15).
                const fmtCartola = (n) => `${moneda(pais)}${Math.round(n).toLocaleString(localString(pais))}`;

                const movsCartola = historico.movimientos || [];
                const lumpCartola = movsCartola.filter((m) => m.pre).reduce((s, m) => s + m.comision, 0);
                const recaudadoPorMes = {};
                movsCartola
                  .filter((m) => !m.pre && m.facturafechacobro)
                  .forEach((m) => {
                    const mes = String(m.facturafechacobro).slice(0, 7);
                    recaudadoPorMes[mes] = (recaudadoPorMes[mes] || 0) + m.comision;
                  });

                const pagosPorMesCartola = {};
                pagosEdificio.forEach((p) => {
                  if (!p.fecha) return;
                  const mes = String(p.fecha).slice(0, 7);
                  pagosPorMesCartola[mes] = (pagosPorMesCartola[mes] || 0) + Number(p.monto || 0);
                });

                // Filas mensuales: unión de meses con recaudado (2026+) y/o pagos, orden ascendente.
                const mesesCartola = [
                  ...new Set([...Object.keys(recaudadoPorMes), ...Object.keys(pagosPorMesCartola)]),
                ].sort();

                // Saldo running: arranca en el lump (apertura); por mes suma recaudado y resta pagos.
                // Puede quedar negativo (anticipos, p.ej. Apoquindo feb–may) — NO se clampa.
                let saldoRun = lumpCartola;
                const filasCartola = mesesCartola.map((mes) => {
                  const rec = recaudadoPorMes[mes] || 0;
                  const pag = pagosPorMesCartola[mes] || 0;
                  saldoRun = saldoRun + rec - pag;
                  return { mes, rec, pag, saldo: saldoRun };
                });

                // Assert del invariante (solo dev): la cartola debe cerrar contra las cards del EECC.
                // No rompe la vista — solo avisa por consola si no cuadra.
                if (process.env.NODE_ENV !== "production" && historico.recaudada != null) {
                  const sumRec = lumpCartola + Object.values(recaudadoPorMes).reduce((s, v) => s + v, 0);
                  const sumPag = Object.values(pagosPorMesCartola).reduce((s, v) => s + v, 0);
                  const saldoFinal = filasCartola.length > 0 ? filasCartola.at(-1).saldo : lumpCartola;
                  const tol = 1;
                  if (Math.abs(sumRec - historico.recaudada) > tol)
                    console.warn(`[cartola] recaudado ${sumRec} ≠ card recaudada ${historico.recaudada}`);
                  if (Math.abs(sumPag - pagadaHistorico) > tol)
                    console.warn(`[cartola] pagos ${sumPag} ≠ card pagada ${pagadaHistorico}`);
                  if (Math.abs(saldoFinal - (historico.recaudada - pagadaHistorico)) > tol)
                    console.warn(
                      `[cartola] saldo final ${saldoFinal} ≠ card saldo ${historico.recaudada - pagadaHistorico}`
                    );
                }

                // Saldo: rojo cuando < 0 (cuenta corriente en negativo por anticipos). Un solo tono de
                // rojo en la tabla (= Pagos, #991b1b). Saldo ≥ 0 en color normal. No se clampa.
                const celdaSaldoCartola = (valor) => (
                  <span style={{ color: valor < 0 ? "#991b1b" : "inherit", fontWeight: 600 }}>{fmtCartola(valor)}</span>
                );
                // Columnas numéricas: derecha + dígitos tabulares. El signo se reemplaza por color:
                // recaudado verde oscuro, pagos rojo oscuro. Celdas vacías ("—") quedan en gris (numCol).
                const numCol = { fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" };
                const numRec = { ...numCol, color: "#166534", fontWeight: 600 };
                const numPag = { ...numCol, color: "#991b1b", fontWeight: 600 };
                return (
                  <>
                    <div style={gridStyle}>
                      <div style={headerSubtitleStyle}>Estado de cuenta histórico — desde 2023 a hoy</div>
                      {kpisEecc.map((kpi) =>
                        renderCard({ ...kpi, dim: historico.loading }, historico.loading ? "..." : undefined)
                      )}
                    </div>
                    <div className="table-responsive" style={{ width: "70%", margin: "8px auto 28px" }}>
                      <h6 style={{ color: "#555", marginBottom: 8 }}>Cartola de cuenta corriente</h6>
                      <table className="table table-fixed table-striped table-bordered table-hover">
                        <colgroup>
                          <col style={{ width: "46%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "18%" }} />
                        </colgroup>
                        <thead className="text-center align-middle">
                          <tr>
                            <th style={{ textAlign: "left" }}>MES</th>
                            <th>RECAUDADO</th>
                            <th>PAGOS</th>
                            <th>SALDO ACUMULADO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-start">Recaudado histórico hasta 31/12/2025</td>
                            <td className="text-end" style={numRec}>
                              {fmtCartola(lumpCartola)}
                            </td>
                            <td className="text-end" style={numCol}>
                              —
                            </td>
                            <td className="text-end" style={numCol}>
                              {celdaSaldoCartola(lumpCartola)}
                            </td>
                          </tr>
                          {filasCartola.map((f) => (
                            <tr key={f.mes}>
                              <td className="text-start">{f.mes}</td>
                              <td className="text-end" style={f.rec ? numRec : numCol}>
                                {f.rec ? fmtCartola(f.rec) : "—"}
                              </td>
                              <td className="text-end" style={f.pag ? numPag : numCol}>
                                {f.pag ? fmtCartola(f.pag) : "—"}
                              </td>
                              <td className="text-end" style={numCol}>
                                {celdaSaldoCartola(f.saldo)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                );
              }

              // Vista "comision" — KPIs del período
              const esGrupo = Array.isArray(facturas);
              const bruto = esGrupo ? facturas.reduce((s, r) => s + r.totalFacturado, 0) : totalesListado.bruto;
              const neto = esGrupo ? facturas.reduce((s, r) => s + r.netoFacturado, 0) : totalesListado.neto;
              const intermediario = esGrupo
                ? bruto != null && neto != null
                  ? bruto - neto
                  : null
                : totalesListado.comisionIntermediario;
              const generada = esGrupo ? facturas.reduce((s, r) => s + r.comisionGenerada, 0) : totalesListado.generada;
              const recaudada = esGrupo
                ? facturas.reduce((s, r) => s + (r.comisionRecaudada || 0), 0)
                : totalesListado.recaudada;
              const pagadaPeriodo = pagosEdificio
                .filter((p) => p.fecha >= fechaInicio && p.fecha <= fechaFin)
                .reduce((s, p) => s + Number(p.monto || 0), 0);
              // Vista "Comisión" = todo período: saldo = recaudada del período − pagada del período
              // (la vista "EECC" usa histórico vía getSaldoEdificio, no se toca).
              const saldo = recaudada != null ? recaudada - pagadaPeriodo : null;

              const kpis = [
                { label: "Facturación Bruta", valor: bruto },
                { label: "Intermediación", valor: intermediario, bg: "#854d0e" },
                { label: "Facturación Neta", valor: neto },
                { label: "Comisión Generada", valor: generada, bg: "#1e40af" },
                { label: labelRecaudada, valor: recaudada, bg: "#5b21b6" },
                { label: "Pagada (período)", valor: pagadaPeriodo, bg: "#166534" },
                { label: "Saldo a Pagar", valor: saldo, bg: "#991b1b" },
              ];

              return (
                <div style={gridStyle}>
                  <div style={headerSubtitleStyle}>Comisión del período seleccionado</div>
                  {kpis.map((kpi) => renderCard(kpi))}
                </div>
              );
            })()}

          {/* ═══ TAB FIJOS ═══ */}
          {pais === "Perú" && activeTab === "fijos" && datosFijos && (
            <div>
              {datosFijos.edificiosFijos.length === 0 ? (
                <p style={{ fontStyle: "italic", color: "#888", marginTop: 8 }}>
                  {datosFijos.esIndividual
                    ? "Este edificio no tiene comisión fija configurada."
                    : "No hay edificios con comisión fija en este grupo."}
                </p>
              ) : datosFijos.esIndividual ? (
                /* Edificio individual: detalle mensual */
                <div>
                  <h6 style={{ marginBottom: 12, color: "#555" }}>
                    Comisión Fija: ${datosFijos.edificiosFijos[0]?.comision_fija_monto} USD/mes desde{" "}
                    {new Date(datosFijos.edificiosFijos[0]?.comision_fija_inicio).toLocaleDateString("es-PE")}
                  </h6>
                  <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                    <thead className="text-center align-middle">
                      <tr>
                        <th width="25%">PERÍODO</th>
                        <th width="25%">MONTO USD</th>
                        <th width="25%">TC (1ro del mes)</th>
                        <th width="25%">MONTO LOCAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosFijos.filas.map((fila) => (
                        <tr key={fila.periodo}>
                          <td className="text-center">{fila.periodo}</td>
                          <td className="text-end">{`$ ${fila.montoUSD.toFixed(2)}`}</td>
                          <td className="text-center">{fila.tc.toFixed(2)}</td>
                          <td className="text-end">
                            {`${moneda(pais)}${Math.round(fila.montoLocal).toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {datosFijos.filas.length > 0 && (
                      <tfoot>
                        <tr className="table-dark">
                          <td className="text-center">
                            <strong>TOTAL</strong>
                          </td>
                          <td className="text-end">
                            <strong>{`$ ${datosFijos.filas.reduce((s, f) => s + f.montoUSD, 0).toFixed(2)}`}</strong>
                          </td>
                          <td className="text-center">—</td>
                          <td className="text-end">
                            <strong>
                              {`${moneda(pais)}${Math.round(
                                datosFijos.filas.reduce((s, f) => s + f.montoLocal, 0)
                              ).toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </strong>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              ) : (
                /* Alianza/Todos: resumen por edificio */
                <div>
                  {/* Totales */}
                  <table className="table table-success table-bordered table-custom table-totales">
                    <thead>
                      <tr className="total-row">
                        <td className="text-start">TOTALES COMISIÓN FIJA</td>
                        <td className="text-end">
                          {`$ ${datosFijos.resumen
                            .reduce((s, r) => s + r.totalUSD, 0)
                            .toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                        </td>
                        <td className="text-end">
                          {`${moneda(pais)}${Math.round(
                            datosFijos.resumen.reduce((s, r) => s + r.totalLocal, 0)
                          ).toLocaleString(localString(pais), {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          })}`}
                        </td>
                        <td className="text-center">100%</td>
                      </tr>
                    </thead>
                  </table>
                  {/* Detalle por edificio */}
                  <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                    <thead className="text-center align-middle">
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">EDIFICIO</th>
                        <th width="15%">USD/MES</th>
                        <th width="10%">MESES</th>
                        <th width="20%">TOTAL USD</th>
                        <th width="25%">TOTAL LOCAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosFijos.resumen.map((r, i) => (
                        <tr key={r.edificio}>
                          <td className="text-center">{i + 1}</td>
                          <td className="text-start uppercase">{r.edificio}</td>
                          <td className="text-end">{`$ ${r.montoMensualUSD.toFixed(2)}`}</td>
                          <td className="text-center">{r.cantMeses}</td>
                          <td className="text-end">
                            {`$ ${r.totalUSD.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </td>
                          <td className="text-end">
                            {`${moneda(pais)}${Math.round(r.totalLocal).toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* ═══ TAB VARIABLE ═══ */}
          {/* CASO EDIFICIO INDIVIDUAL → ListadoFacturas. El detalle de facturas NO se muestra en la
              vista EECC (queda solo en la vista Comisión, que justifica el número; ver P2.15). */}
          {activeTab === "variable" && vistaActiva !== "eecc" && facturas?.listado?.length > 0 ? (
            <ListadoFacturas
              facturas={facturas.listado}
              comisionEdificio_1_porcentaje={facturas.comisionEdificio_1_porcentaje}
              comisionEdificio_1_fechainicio={facturas.comisionEdificio_1_fechainicio}
              comisionEdificio_1_fechafin={facturas.comisionEdificio_1_fechafin}
              comisionEdificio_2_porcentaje={facturas.comisionEdificio_2_porcentaje}
              comisionEdificio_2_fechainicio={facturas.comisionEdificio_2_fechainicio}
              comisionEdificio_2_fechafin={facturas.comisionEdificio_2_fechafin}
              comisionEdificio_3_porcentaje={facturas.comisionEdificio_3_porcentaje}
              comisionEdificio_3_fechainicio={facturas.comisionEdificio_3_fechainicio}
              comisionEdificio_3_fechafin={facturas.comisionEdificio_3_fechafin}
              pantallasEdificio={facturas.pantallasEdificio}
              edificioId={facturas.edificioId || null}
              snapMap={snapMap}
              pais={pais}
              labelCobrada={pais === "Chile" ? "RECAUDADA" : "COBRADA"}
              onTotalesCalculados={handleTotalesCalculados}
              mostrarFooter={false}
              onDetalle={(sale) => setSelectedSale(sale)}
            />
          ) : activeTab === "variable" && vistaActiva !== "eecc" && facturas?.listado?.length === 0 ? (
            <p>No hay ventas para este edificio en estas fechas.</p>
          ) : (
            /* CASO "TODOS" O ALIANZA → Tabla de resumen */
            activeTab === "variable" &&
            vistaActiva !== "eecc" &&
            facturas &&
            facturas.length > 0 &&
            (() => {
              const totalComisionGenerada = facturas.reduce((t, i) => t + i.comisionGenerada, 0);
              return (
                <div>
                  {/* TU TABLA DE TOTALES (la que ya tenías) */}
                  <table className="table table-success table-bordered table-custom table-totales">
                    <thead>
                      <tr className="total-row">
                        <td className="text-start">TOTALES</td>
                        <td className="text-end">
                          {`${moneda(pais)} ${facturas
                            .reduce((total, resumen) => total + resumen.totalFacturado, 0)
                            .toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                        </td>
                        <td className="text-end">
                          {`${moneda(pais)} ${facturas
                            .reduce((total, resumen) => total + resumen.netoFacturado, 0)
                            .toLocaleString(localString(pais), {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            })}`}
                        </td>
                        <td className="text-end">
                          {`${moneda(pais)} ${totalComisionGenerada.toLocaleString(localString(pais), {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          })}`}
                        </td>
                        <td className="text-center">
                          {facturas
                            .reduce((total, resumen) => {
                              const porcentaje = totalComisionGenerada
                                ? (resumen.comisionGenerada / totalComisionGenerada) * 100
                                : 0;
                              return total + porcentaje;
                            }, 0)
                            .toFixed(0)}
                          %
                        </td>
                      </tr>
                    </thead>
                  </table>

                  <table className="table table-striped table-bordered table-hover table-custom table-detalles">
                    <thead className="text-center align-middle">
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">EDIFICIO</th>
                        <th width="20%">FACTURACIÓN BRUTA</th>
                        <th width="20%">FACTURACIÓN NETA</th>
                        <th width="20%">COMISIÓN GENERADA</th>
                        <th width="10%">%</th>
                      </tr>
                    </thead>
                    <tbody>
                      {facturas.map((resumen, index) => {
                        const porcentajeComision = totalComisionGenerada
                          ? (resumen.comisionGenerada / totalComisionGenerada) * 100
                          : 0;
                        return (
                          <tr key={resumen.edificio}>
                            <td className="text-center">{index + 1}</td>
                            <td className="text-start uppercase">{resumen.edificio}</td>
                            <td className="text-end">
                              {`${moneda(pais)} ${resumen.totalFacturado.toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </td>
                            <td className="text-end">
                              {`${moneda(pais)} ${resumen.netoFacturado.toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </td>
                            <td className="text-end">
                              {`${moneda(pais)} ${resumen.comisionGenerada.toLocaleString(localString(pais), {
                                minimumFractionDigits: decimales(pais),
                                maximumFractionDigits: decimales(pais),
                              })}`}
                            </td>
                            <td className="text-center">{porcentajeComision.toFixed(1)}%</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              );
            })()
          )}

          {activeTab === "variable" && facturas && facturas.length === 0 && (
            <p>
              No hay ventas para{" "}
              {edificioSeleccionado === "todos"
                ? "los edificios"
                : esSeleccionSocio(edificioSeleccionado)
                  ? `el dueño ${socios.find((s) => s.id === socioIdSel(edificioSeleccionado))?.nombre || ""}`
                  : "este edificio"}{" "}
              en estas fechas.
            </p>
          )}

          {/* Modal "Detalle cálculo" por venta. El recorte es por CONTEXTO DE VISTA, no por rol:
              estamos mirando un edificio puntual, así que solo ese edificio muestra %/costo de
              comisión (resto "—"). Aplica a todos los roles, incluido superadmin. */}
          {selectedSale && (
            <BuildingDetailsModal
              opportunity={selectedSale}
              buildings={edificiosMapModal}
              clientes={clientes}
              intermediarios={intermediarios}
              pais={pais}
              snapMap={snapMap}
              pctMap={pctMap}
              takeLocal={getTakeLocal(
                selectedSale,
                "sales",
                selectedSale?.id,
                costosMap,
                getDolarValue,
                dolarFallback[pais]
              )}
              getRate={getRateModal}
              moneda={moneda(pais).trim()}
              localString={localString(pais)}
              decimales={decimales(pais)}
              edificiosVisibles={facturas?.edificioId != null ? [facturas.edificioId] : null}
              onClose={() => setSelectedSale(null)}
            />
          )}
        </>
      )}
    </div>
  );
};
